import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const styles = StyleSheet.create({

    compTitle: {
        fontFamily: 'Antenna',
        fontSize: '13px',
        fontWeight: fontWeight.semibold,
        letterSpacing: '2px',
        textAlign: 'center',
        color: color.white,
        marginTop: 0,
        textTransform: 'uppercase',
    },

    divider: {
        width:'100%',
        height: '1px',
        opacity: 0.1,
        backgroundColor: color.white,
        display: 'block',
        margin: '20px 0'
    },

    playlistCont: {
        width: '100%',
        maxHeight: '88%',
        overflowY: 'auto',
        '::-webkit-scrollbar': { 
            display: 'none',
        },

        [media.TABLET]: {
            maxHeight: '84%'
        },
        [media.MOBILE]: {
            maxHeight: '300px',
            '-webkit-overflow-scrolling': 'touch',
        }
    },

});


// WEBPACK FOOTER //
// ./react-app-src/videoPlayer/components/styles/VideoPlaylistStyles.js